import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill name, email and message.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Thanks — we'll get back to you soon!");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Failed to send. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <section className="sd-page-hero">
        <h1>Contact Us</h1>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl text-[#cd0202] font-display mb-4">Send us a message</h2>
            <p className="text-gray-700 mb-6">
              Questions, catering inquiries, or just want to say hi? Drop us a line.
            </p>
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <input
                type="text"
                placeholder="Name *"
                value={form.name}
                onChange={upd("name")}
                className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:border-[#cd0202]"
                data-testid="contact-name"
              />
              <input
                type="email"
                placeholder="Email *"
                value={form.email}
                onChange={upd("email")}
                className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:border-[#cd0202]"
                data-testid="contact-email"
              />
              <input
                type="tel"
                placeholder="Phone"
                value={form.phone}
                onChange={upd("phone")}
                className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:border-[#cd0202]"
                data-testid="contact-phone"
              />
              <input
                type="text"
                placeholder="Subject"
                value={form.subject}
                onChange={upd("subject")}
                className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:border-[#cd0202]"
                data-testid="contact-subject"
              />
              <textarea
                rows={5}
                placeholder="Message *"
                value={form.message}
                onChange={upd("message")}
                className="w-full border border-gray-300 px-4 py-3 rounded focus:outline-none focus:border-[#cd0202]"
                data-testid="contact-message"
              />
              <button
                type="submit"
                disabled={loading}
                className="sd-btn-red"
                data-testid="contact-submit"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          <div className="bg-[#f6f1e8] p-8 rounded">
            <h2 className="text-2xl text-[#cd0202] font-display mb-4">Visit us</h2>
            <div className="mb-6">
              <p className="font-display text-gray-800">Rochester Rd. Shop (NEW)</p>
              <p className="text-gray-700">7279 Rochester Rd<br />Lockport, NY 14094</p>
              <p className="text-[#cd0202] font-semibold">(716) 438-7183</p>
            </div>
            <div className="mb-6">
              <p className="font-display text-gray-800">Locust St. Shop</p>
              <p className="text-gray-700">Locust Street<br />Lockport, NY</p>
              <p className="text-[#cd0202] font-semibold">(716) 433-0011</p>
            </div>
            <div>
              <p className="font-display text-gray-800 mb-1">Hours</p>
              <p className="text-gray-600 text-sm">Mon–Thu: 10:30 AM – 9:00 PM</p>
              <p className="text-gray-600 text-sm">Fri–Sat: 10:30 AM – 10:00 PM</p>
              <p className="text-gray-600 text-sm">Sun: 11:00 AM – 8:00 PM</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
